<div class="modal-header">
    <span class="application-title modal-title" id="modal-title">{{ lang.GetValue('InfoMenu.About') }} {{ applicationName }}</span>
    <button type="button" class="btn-close" aria-describedby="modal-title" (click)="dismiss()"
        aria-label="Stäng modal"></button>
</div>
<div class="modal-body">
     @if (environment.application == "NjdbPåWebb") {
    <div>

        <div class="info_txt">260122: Just nu är det driftstörningar som gör att det är problem att visa kartlager. Felsökning pågår.</div>
            <br />
        <div class="about-title">Här kan du betrakta NJDB - Sveriges järnvägsnät på en karta</div>
        <div class="about-body">
            I tjänsten NJDB på webb kan du överblicka Sveriges järnvägar. Du kan välja att titta på flera egenskaper på
            järnvägnätet till exempel
            bandelsnummer. Du kan även titta på data som endast finns för det statliga järnvägsnätet.
            <br />
            <br />
            Ändringar i NJDB syns inte i {{ applicationName }} förrän nästa dag
        </div>

        <div class="about-title">Mer om Nationella järnvägsdatabasen</div>
        <div class="about-body">
            <a href="https://bransch.trafikverket.se/tjanster/data-kartor-och-geodatatjanster/las-om-vara-data/jarnvagsdata/"
                target="__blank">
                NJDB - Nationell järnvägsdatabas
            </a>
        </div>

        <div class="about-title">Användarhandledning</div>
        <div class="about-body">
            <a [href]="nvdbNavigationService.HANDLEDNING_PATH" target="__blank">
                {{ nvdbNavigationService.HANDLEDNING_FILENAME }} ({{ nvdbNavigationService.HANDLEDNING_FILESIZE }})
            </a>
        </div>

        <div class="about-title">Vid frågor eller synpunkter</div>
        <div class="about-body">
            <a href="mailto:njdb@trafikverket.se?subject=Synpunkt">njdb&#64;trafikverket.se</a>
        </div>
    </div>

    } @if (environment.application == "JNBKarta") {
    <div>

        <div class="info_txt">260122: Just nu är det driftstörningar som gör att det är problem att visa kartlager. Felsökning pågår.</div>
            <br/>
        <div class="about-title">{{ lang.GetValue('InfoMenu.TxtHeadlineFirst') }}</div>
        <div class="about-body">
            {{ lang.GetValue('InfoMenu.TxtInfoFirst') }}
            <br />
            <br />
            {{ lang.GetValue('InfoMenu.TxtInfoSecondFirst') }} {{ applicationName }} {{ lang.GetValue('InfoMenu.TxtInfoSecondLast') }}
        </div>

        <div class="about-title">{{ lang.GetValue('InfoMenu.TxtHeadlineSecond') }}</div>
        <div class="about-body">
            <a href="https://bransch.trafikverket.se/for-dig-i-branschen/jarnvag/jarnvagsnatsbeskrivningen-jnb/"
                target="__blank">
                {{ lang.GetValue('InfoMenu.DescLink') }}
            </a>
        </div>

        <div class="about-title">{{ lang.GetValue('InfoMenu.TxtHeadlineThird') }}</div>
        <div class="about-body">
            <a [href]="nvdbNavigationService.HANDLEDNING_PATH" target="__blank">
                {{ nvdbNavigationService.HANDLEDNING_FILENAME }} ({{ nvdbNavigationService.HANDLEDNING_FILESIZE }})
            </a>
        </div>

        <div class="about-title">{{ lang.GetValue('InfoMenu.Questions') }}</div>
        <div class="about-body">
            <a href="mailto:njdb@trafikverket.se?subject=Synpunkt">jnb&#64;trafikverket.se</a>
        </div>
    </div>

    }
</div>
<div class="modal-footer" style="justify-content: space-between !important">
    <span style="">
        <b>Version:</b>
        {{ version }}
    </span>
    <button type="button" class="btn btn-link" (click)="close()">{{ lang.GetValue('MapMenu.Close') }}</button>
</div>